"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFakeAccessToken = exports.getFakeIdToken = exports.createMockAuthClient = exports.createMockAuthProvider = void 0;
var auth_api_1 = require("@newfront-insurance/auth-api");
var react_provision_1 = require("@newfront-insurance/react-provision");
var jsonwebtoken_1 = require("jsonwebtoken");
var react_1 = require("react");
var auth_provider_1 = require("./auth-provider");
var createMockAuthProvider = function (options) {
    return (0, react_provision_1.createProvider)(function () {
        var client = createMockAuthClient(options);
        var authState = (0, auth_provider_1.useAuthState)(client);
        var userDetails = (0, auth_provider_1.useUserProfile)(authState);
        var logout = (0, react_1.useCallback)(function (redirectUrl) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, client.logout(redirectUrl)];
        }); }); }, [client]);
        var getAccessTokenCallback = (0, auth_provider_1.useAccessTokenCallback)(client);
        return {
            getAccessTokenCallback: getAccessTokenCallback,
            getToken: getAccessTokenCallback,
            logout: logout,
            userDetails: userDetails,
            authState: authState,
            client: client,
        };
    }, {
        name: 'AuthProviderMock',
    });
};
exports.createMockAuthProvider = createMockAuthProvider;
function createMockAuthClient(options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var onLogout = options.onLogout, _a = options.onLogin, onLogin = _a === void 0 ? function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); } : _a;
    return {
        login: onLogin,
        start: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, true];
            });
        }); },
        stop: function () {
            return true;
        },
        subscribe: function () {
            return function () {
                return true;
            };
        },
        updateTokens: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        idToken: '12345',
                        token: '12345',
                    })];
            });
        }); },
        getAuthState: function () {
            var _a, _b;
            return ({
                state: 'LOGGED_IN',
                isLoggedIn: true,
                isReady: true,
                idToken: getFakeIdToken((_a = options.user) !== null && _a !== void 0 ? _a : {}),
                token: getFakeAccessToken((_b = options.user) !== null && _b !== void 0 ? _b : {}),
            });
        },
        logout: function (redirectUri) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (onLogout) {
                    onLogout(redirectUri);
                }
                return [2 /*return*/];
            });
        }); },
        swap: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        token: '',
                        refreshToken: '',
                    }];
            });
        }); },
    };
}
exports.createMockAuthClient = createMockAuthClient;
function getFakeIdToken(userDetails) {
    function getFullName() {
        var firstName = userDetails.firstName || '';
        var lastName = userDetails.lastName || '';
        return "".concat(firstName, " ").concat(lastName).trim();
    }
    return (0, jsonwebtoken_1.sign)(__assign(__assign({}, EMPTY_IDENTITY), {
        email_verified: true,
        profilePic: userDetails.profilePic || '',
        email: userDetails.email || 'foo@bar.com',
        given_name: userDetails.firstName || 'John',
        family_name: userDetails.lastName || 'Doe',
        name: getFullName() || 'John Doe',
        userId: userDetails.uuid || '123456',
    }), 'foo');
}
exports.getFakeIdToken = getFakeIdToken;
function getFakeAccessToken(userDetails) {
    var _a;
    var decodedJwt = __assign(__assign({}, EMPTY_USER_PROFILE), userDetails);
    return (0, jsonwebtoken_1.sign)(__assign(__assign({}, decodedJwt), { scope: (_a = decodedJwt.scopes) === null || _a === void 0 ? void 0 : _a.join(' ') }), 'foo');
}
exports.getFakeAccessToken = getFakeAccessToken;
var EMPTY_IDENTITY = {
    email_verified: true,
    profilePic: '',
    email: 'foo@bar.com',
    given_name: 'John',
    family_name: 'Doe',
    name: 'John Doe',
    userId: '123456',
};
var EMPTY_USER_PROFILE = {
    roles: [],
    scopes: [auth_api_1.AuthRole.ENGINEER],
    accounts: [],
    email: 'foo@bar.com',
    firstName: 'John',
    lastName: 'Doe',
    uuid: '123456',
};
